//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: 'Nenhum resultado encontrado'
    },

    subtitle: {
      type: String,
      default: ''
    }
  }
}
